<template>
  <div class="form-floating mb-3 position-relative">
    <!-- Ícone dentro do campo -->
    <img 
      v-if="iconSrc" 
      :src="iconSrc" 
      :alt="altText" 
      class="position-absolute top-50 start-0 translate-middle-y ps-3" 
      width="40px" 
      style="z-index: 9;"
    />

    <!-- Input de CEP -->
    <input
      :value="modelValue"
      :disabled="!isEditable"
      :placeholder="placeholder"
      :id="inputId"
      class="form-control ps-5"
      inputmode="numeric"
      @input="onInput"
      @change="$emit('change')"
      required
    >

    <!-- Label flutuante -->
    <label :for="inputId" class="ps-5">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'CepInputWithIcon',
  props: {
    modelValue: { type: String, required: true },
    isEditable: { type: Boolean, default: true },
    placeholder: { type: String, default: 'CEP' },
    label: { type: String, default: 'CEP' },
    inputId: { type: String, default: 'cep' },
    iconSrc: { type: String, default: 'https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3' },
    altText: { type: String, default: 'Ícone de CEP' },
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    formatCep(value) {
      // Remove tudo que não é número
      let digits = value.replace(/\D/g, '');
      if (digits.length > 5) {
        digits = digits.replace(/^(\d{5})(\d{0,3})/, '$1-$2');
      }
      return digits;
    },
    onInput(event) {
      const formatted = this.formatCep(event.target.value);
      this.$emit('update:modelValue', formatted);
    }
  }
}
</script>

<style scoped>
.form-floating input {
  padding-left: 43px !important;
}

.form-floating img {
  z-index: 9;
}

.error-border {
  border: 1px solid red !important;
  border-radius: 0.75rem !important;
}

.text-danger {
  width: 100%;
  text-align: left;
  padding: 5px;
}

.form-control {
    height: 66px !important;
    border-radius: .75rem;
}
</style>
